const authentication = require('../../../react-azure-adb2c2').default;



export const detail = (values: any) => {
  
  // let url = `http://localhost:5000/v1/room/support/m/devices/detail`;
  let url = process.env.REACT_APP_ROOM_SUPPORT_API_URL + `/v1/room/support/m/devices/detail`;
  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};